export const BUCKET_QUERY_PARAM_KEY = 's';
export const NAVIGATION_QUERY_PARAM_KEY = 'navigation';
export const OVERLAY_QUERY_PARAM_KEY = 'overlay';
export const SEARCH_QUERY_PARAM_KEY = 'search';
export const PAGE_QUERY_PARAM_KEY = 'p';
export const POSITION_ID_QUERY_PARAM_KEY = 'id';
export const SELECTED_JOB_APPLICATION_PARAM_KEY = 'selected';
export const JOB_ID_QUERY_PARAM_KEY = 'jobid';
export const REFERRER_QUERY_PARAM_KEY = 'referrer';
export const CANDIDATE_PROFILE_DRAWER_TAB_PARAM_KEY = 'tab';
export const PAGE_TAB_PARAM_KEY = 'page';
